import { withPublicAssetUrl } from '@lib/utils/cdn'

import styles from './grammarly-coda.module.scss'

const GridShape = () => (
  <img
    src={`${withPublicAssetUrl('background-asset/coda-grammarly/grid.svg')}`}
    alt="Grid shape"
    className={styles.gridShape}
  />
)

const CodaShape = () => (
  <>
    <img
      src={`${withPublicAssetUrl('background-asset/coda-grammarly/coda.svg')}`}
      alt="Coda shape"
      className={styles.codaShapeIcon}
    />
    <div className={styles.codaSpacer}></div>
  </>
)

const GrammarlyShape = () => (
  <>
    <div className={styles.grammarlySpacer} />
    <img
      src={`${withPublicAssetUrl('background-asset/coda-grammarly/grammarly.svg')}`}
      alt="Grammarly shape"
      className={styles.grammarlyShapeIcon}
    />
  </>
)

export const getGrammarlyCodaAsset = () => {
  return {
    top: GrammarlyShape,
    background: GridShape,
    bottom: CodaShape,
  }
}
